var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIphone12BlackInset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 22,
    viewBox: "0 0 150 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.29612e-05V0H149.046C148.361 0 148.018 0 147.744 0.0998191C147.285 0.267155 146.922 0.629319 146.755 1.08907C146.655 1.36332 146.655 1.70582 146.655 2.3908C146.655 7.87072 146.655 10.6107 145.857 12.8047C144.518 16.4827 141.621 19.38 137.943 20.7187C135.749 21.5172 133.009 21.5172 127.529 21.5172H21.3678C15.8879 21.5172 13.148 21.5172 10.954 20.7187C7.27595 19.38 4.37863 16.4827 3.03995 12.8047C2.24139 10.6107 2.24139 7.87072 2.24139 2.3908C2.24139 1.70582 2.24139 1.36332 2.14157 1.08907C1.97424 0.629319 1.61208 0.267155 1.15232 0.0998191C0.89878 0.00753647 0.586906 0.000569013 0 4.29612e-05Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 10.793C60 9.19331 61.2968 7.89648 62.8966 7.89648H89.3793C90.979 7.89648 92.2759 9.19331 92.2759 10.793C92.2759 12.3928 90.979 13.6896 89.3793 13.6896H62.8966C61.2968 13.6896 60 12.3928 60 10.793Z",
    fill: "#161616"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8966 8.89648H89.3793C90.4267 8.89648 91.2759 9.7456 91.2759 10.793C91.2759 11.8405 90.4267 12.6896 89.3793 12.6896H62.8966C61.8491 12.6896 61 11.8405 61 10.793C61 9.7456 61.8491 8.89648 62.8966 8.89648Z",
    stroke: "black",
    strokeOpacity: 0.32,
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8966 8.39648H89.3793C90.7029 8.39648 91.7759 9.46946 91.7759 10.793C91.7759 12.1166 90.7029 13.1896 89.3793 13.1896H62.8966C61.573 13.1896 60.5 12.1166 60.5 10.793C60.5 9.46946 61.573 8.39648 62.8966 8.39648Z",
    stroke: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8966 10.7931C98.8966 7.59366 101.49 5 104.69 5C107.889 5 110.483 7.59366 110.483 10.7931C110.483 13.9925 107.889 16.5862 104.69 16.5862C101.49 16.5862 98.8966 13.9925 98.8966 10.7931Z",
    fill: "url(#paint1_radial)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8966 10.7931C98.8966 7.59366 101.49 5 104.69 5C107.889 5 110.483 7.59366 110.483 10.7931C110.483 13.9925 107.889 16.5862 104.69 16.5862C101.49 16.5862 98.8966 13.9925 98.8966 10.7931Z",
    fill: "url(#paint2_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.586 10.793C107.586 9.19331 106.289 7.89648 104.69 7.89648C103.09 7.89648 101.793 9.19331 101.793 10.793C101.793 12.3928 103.09 13.6896 104.69 13.6896C106.289 13.6896 107.586 12.3928 107.586 10.793Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.586 10.793C107.586 9.19331 106.289 7.89648 104.69 7.89648C103.09 7.89648 101.793 9.19331 101.793 10.793C101.793 12.3928 103.09 13.6896 104.69 13.6896C106.289 13.6896 107.586 12.3928 107.586 10.793Z",
    fill: "url(#paint4_radial)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.586 10.793C107.586 9.19331 106.289 7.89648 104.69 7.89648C103.09 7.89648 101.793 9.19331 101.793 10.793C101.793 12.3928 103.09 13.6896 104.69 13.6896C106.289 13.6896 107.586 12.3928 107.586 10.793Z",
    fill: "url(#paint5_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.586 10.793C107.586 9.19331 106.289 7.89648 104.69 7.89648C103.09 7.89648 101.793 9.19331 101.793 10.793C101.793 12.3928 103.09 13.6896 104.69 13.6896C106.289 13.6896 107.586 12.3928 107.586 10.793Z",
    fill: "url(#paint6_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.586 10.793C107.586 9.19331 106.289 7.89648 104.69 7.89648C103.09 7.89648 101.793 9.19331 101.793 10.793C101.793 12.3928 103.09 13.6896 104.69 13.6896C106.289 13.6896 107.586 12.3928 107.586 10.793Z",
    fill: "url(#paint7_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 60,
    y: 7.89648,
    width: 32.2759,
    height: 5.7931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 59,
    y: 6.89648,
    width: 34.2759,
    height: 7.7931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 76.1379,
    y1: 7.89648,
    x2: 76.1379,
    y2: 13.6896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483028,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.724 13.4828) rotate(-127.694) scale(5.75232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.69 10.7931) rotate(90) scale(5.7931)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 104.69,
    y1: 7.89648,
    x2: 104.69,
    y2: 13.6896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B528D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#3625AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#070D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#16618F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021762"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.414 10.1723) rotate(58.3925) scale(3.15814)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070D17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.104 11.2068) rotate(106.699) scale(2.16006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.146834,
    stopColor: "#070D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070D17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.517 10.1723) rotate(128.66) scale(1.32478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6356D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15368A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.69 10.793) rotate(90) scale(2.89655)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.85
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone12BlackInset);
export default __webpack_public_path__ + "static/media/iphone-12--black--inset.f83eada42dd816097e1e5685ada5cf16.svg";
export { ForwardRef as ReactComponent };